import React from 'react';

const NoWorkspaceAccessPage = () => {
    return (
        <div style={{ padding: 24 }}>
            <h2>No workspace access</h2>
            <p>Your account is not assigned to any workspace. Please contact your administrator.</p>
        </div>
    );
};

export default NoWorkspaceAccessPage;

